import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ProvinceCardComponent from './ProvinceCardComponent';
import WeatherComponent from './WeatherComponent'; // Import the new component

const DashboardProvinceCards = ({ onViewDeptDetails, onViewPublicDetails }) => {
  const [data, setData] = useState({
    punjab: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    kpk: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    gilgitBaltistan: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    sindh: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    ajk: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    balochistan: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
    ict: { totalPlantation: 0, byGeneralPublic: 0, byDepartment: 0, activeUsers: 0 },
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  // Fetch province stats
  useEffect(() => {
    const fetchProvinceStats = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found. Please log in.');
          setLoading(false);
          return;
        }

        const response = await fetch(
          `${process.env.REACT_APP_BE_API_URL}/api/plantation/pafs/provincial-level-summary`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const result = await response.json();

        if (response.ok && result.status && result.data) {
          const mappedData = { ...data };

          result.data.forEach((item) => {
            const provinceKey = {
              'Azad Jammu & Kashmir': 'ajk',
              'Gilgit-Baltistan': 'gilgitBaltistan',
              Sindh: 'sindh',
              'Khyber Pakhtunkhwa': 'kpk',
              'Islamabad Capital Territory': 'ict',
              Punjab: 'punjab',
              Balochistan: 'balochistan',
            }[item.province];

            if (provinceKey) {
              mappedData[provinceKey] = {
                totalPlantation: item.totalPlants,
                byGeneralPublic: item.publicPlants,
                byDepartment: item.departmentalPlants,
                activeUsers: item.activeUsers,
              };
            }
          });

          setData(mappedData);
          setLoading(false);
        } else {
          setError(result.message || 'Failed to fetch province statistics.');
          setLoading(false);
        }
      } catch (error) {
        setError('Error fetching province stats: ' + error.message);
        setLoading(false);
        console.error('Error fetching province stats:', error);
      }
    };

    fetchProvinceStats();
    // eslint-disable-next-line
  }, []);

  const statusCards = [
    {
      title: 'Punjab',
      value: data.punjab,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686370460-punjab.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755683580659-Punjab.webp',
      cardClass: 'bg-gradient-to-r from-green-400 to-green-600',
    },
    {
      title: 'Sindh',
      value: data.sindh,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686774778-Sindh.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755776700893-Sindh2.webp',
      cardClass: 'bg-gradient-start-4',
    },
    {
      title: 'Islamabad Capital Territory',
      value: data.ict,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/PPMS/large-1756184757122-ICT3.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/PPMS/large-1756120834793-ICT.webp',
      cardClass: 'bg-gradient-start-5',
    },
    {
      title: 'Balochistan',
      value: data.balochistan,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686953213-Balochistan.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/PPMS/large-1756118817645-Balochistan-2.webp',
      cardClass: 'bg-gradient-start-6',
    },
    {
      title: 'Khyber Pakhtunkhwa',
      value: data.kpk,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686546872-KPK.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755684593273-kpk.webp',
      cardClass: 'bg-gradient-start-11',
    },
    {
      title: 'Gilgit-Baltistan',
      value: data.gilgitBaltistan,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686646129-GB.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755684640923-GB.webp',
      cardClass: 'bg-gradient-start-2',
    },
    {
      title: 'AJK',
      value: data.ajk,
      icon: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686870834-AJK.webp',
      cover: 'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755684711172-AJK.webp',
      cardClass: 'bg-gradient-start-5',
    },
  ];

  const ictCard = statusCards.find((card) => card.title === 'Islamabad Capital Territory');
  const remainingCards = statusCards.filter((card) => card.title !== 'Islamabad Capital Territory');

  if (error) {
    return <div className="alert alert-danger text-center">{error}</div>;
  }

  return (
    <div>
      {/* ICT + Weather row */}
      <div className="row justify-content-center mt-5">
        {/* ICT Card */}
        <div className="col-12 col-md-6 col-lg-4">
          {loading ? (
            <Skeleton height={250} />
          ) : (
            ictCard && (
              <ProvinceCardComponent
                card={ictCard}
                onViewDeptDetails={onViewDeptDetails}
                onViewPublicDetails={onViewPublicDetails}
              />
            )
          )}
        </div>

        {/* Weather Widget */}
        <div className="col-12 col-md-6 col-lg-4">
          <WeatherComponent/>
        </div>
      </div>

      {/* Remaining Cards */}
      <div className="row row-cols-xxxl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-4 mt-5">
        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <div className="col" key={index}>
                <Skeleton height={250} />
              </div>
            ))
          : remainingCards.map((card, index) => (
              <div className="col" key={index}>
                <ProvinceCardComponent
                  card={card}
                  onViewDeptDetails={onViewDeptDetails}
                  onViewPublicDetails={onViewPublicDetails}
                />
              </div>
            ))}
      </div>
    </div>
  );
};

export default DashboardProvinceCards;